module.exports = __webpack_public_path__ + "img/training_icon.0f47a7ff.svg";